export interface ThankYouPageSettingProfileOutputApiModel {
    display_name: string;
    title: string;
    company_name: string;
}

export interface ButtonOutputApiModel {
    text: string;
    link: string;
    color: string;
}

export interface ThankYouPageSettingButtonOutputApiModel {
    color: string;
    url: string;
    text: string;
    background: string;
    isActive: boolean;
}

export interface ThankYouPageSettingOutputApiModel {
    image: string;
    profile: ThankYouPageSettingProfileOutputApiModel;
    title: string;
    content: string;
    buttons: ThankYouPageSettingButtonOutputApiModel[];
}